/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function() {
	
	// Remove empty P tags created by WP inside of Accordion and Orbit
	jQuery('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
		  jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
		  jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});

	function getFileName(input){
    if (input.files && input.files.length) return input.files[0].name;
    // Fallback voor Safari/legacy
    return (input.value || '').split(/[\\/]/).pop();
  }

  function bindFileUI(wrapperSelector, inputSelector, labelSelector, defaultText){
    // change gedelegeerd: CF7 kan het input-element vervangen
    $(document).on('change', wrapperSelector + ' ' + inputSelector, function(){
      var name = getFileName(this);

      // Zoek het label binnen dezelfde button-wrapper
      var $wrap  = $(this).closest(wrapperSelector);
      var $label = $wrap.find(labelSelector);
      var $span  = $label.find('span');

      if (!$span.length) { $label.wrapInner('<span></span>'); $span = $label.find('span'); }

      $span.text(name || defaultText);
      $label.toggleClass('has-file', !!name);
    });
  }

  // Koppelen per blok (werkt ook met meerdere formulieren op 1 pagina)
  bindFileUI('.cvbutton',         'input[type=file].uploadcv',         '#cvbrowsebutton',         'Upload je CV (optioneel)');
  bindFileUI('.motivatiebutton',  'input[type=file].uploadmotivatie',  '#motivatiebrowsebutton',  'Upload je motivatiebrief (optioneel)');

  // Reset teksten na verzenden/reset van CF7
  document.addEventListener('wpcf7mailsent', function(){
    $('#cvbrowsebutton span').text('Upload je CV (optioneel)').end().removeClass('has-file');
    $('#motivatiebrowsebutton span').text('Upload je motivatiebrief (optioneel)').end().removeClass('has-file');
  }, false);
  document.addEventListener('wpcf7reset', function(){
    $('#cvbrowsebutton span').text('Upload je CV (optioneel)').end().removeClass('has-file');
    $('#motivatiebrowsebutton span').text('Upload je motivatiebrief (optioneel)').end().removeClass('has-file');
  }, false);
}); 